import { AddressParamsModel, RequestParams } from 'Models'
import { urls } from 'Constants/Urls'
import { axiosDS } from '@pp/axios'
import { AddressModel, Appointment } from 'Pages/registratorCabinet'
import { SimpleResponse } from 'Types/simpleResponse'

export const outOfficeRegistratorCabinetApi = {
	getCitiesRegions: async (requestParams: RequestParams) => {
		const { order_id, ...otherParams } = requestParams
		const res = await axiosDS().get<SimpleResponse>(
			urls.cabinet.cities_regions.replace(':id', String(order_id)),
			{ params: otherParams }
		)
		return res.data
	},
	getSlots: async (requestParams: RequestParams) => {
		const { order_id, ...otherParams } = requestParams
		const res = await axiosDS().get<SimpleResponse>(
			urls.cabinet.slots.replace(':id', String(order_id)),
			{ params: otherParams }
		)
		return res.data
	},
	createAppointment: async (data: Appointment) => {
		const res = await axiosDS().post<Appointment>(
			urls.cabinet.appointment.replace(':id', String(data.order_id)),
			data
		)
		return res.data
	},
	getAddress: async (params: AddressParamsModel) => {
		const res = await axiosDS().get<AddressModel[]>(urls.dadata.address, { params })
		return res.data
	},
}
